import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import toastr from "toastr";
import SettingsInput from "./SettingsInput";
import SettingsWrapper from "../../common/ScrollableWrapper/SettingsWrapper";
import { getAccountById, updateAccountAdvanced } from "services/account/account.service";

const MAX_URL_LENGTH = 150;

const AccountAdvancedSettings = ({ user }) => {
  const { register, handleSubmit, errors } = useForm();
  const [form, setForm] = useState({
    orderUrl: "",
    profileUrl: ""
  });
  const [loading, setLoading] = useState(false);

  const fetchAccount = async () => {
    if (!user) return;

    setLoading(true);
    const res = (await getAccountById(user.accountId)).data();
    setForm({
      orderUrl: res?.settings?.advanced?.orderUrl || "",
      profileUrl: res?.settings?.advanced?.profileUrl || ""
    });
    setLoading(false);
  };

  useEffect(() => {
    fetchAccount();
    // eslint-disable-next-line
  }, [user.accountId]);

  const onSubmit = async () => {
    if (loading || !user) return;
    try {
      setLoading(true);
      await updateAccountAdvanced(user.accountId, {
        orderUrl: form.orderUrl.trim(),
        profileUrl: form.profileUrl.trim()
      });
      setLoading(false);
      toastr.success(`Settings updated`);
    } catch (e) {
      setLoading(false);
      toastr.error(`Something went wrong`);
    }
  };

  const onChangeFormField = event => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const validateUrl = url => {
    if (!url) return true;
    const domainRegex = /^(((https):\/\/|)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?)$/;
    return domainRegex.test(url.trim());
  };

  return (
    <SettingsWrapper
      title={"OMS+"}
      handleSubmit={handleSubmit(onSubmit)}
      buttonStyles={{ maxWidth: 600 }}
      submitBtnDisabled={loading}
    >
      <Row>
        <Col md={12}>
          <SettingsInput
            placeholder={"https://www.example.com"}
            form={form}
            value={form.orderUrl}
            enabled={true}
            allowEdit={true}
            name={"orderUrl"}
            type={"text"}
            inputStyles={{ width: "400px" }}
            errors={errors}
            label={"OMS+ Order URL"}
            subtitle={"The Url to open an order in OMS+. Applies to all locations unless overridden."}
            onChangeValue={onChangeFormField}
            register={register({
              validate: validateUrl,
              maxLength: { value: MAX_URL_LENGTH, message: `URL must be fewer than ${MAX_URL_LENGTH} characters` }
            })}
            validateMessage={"Invalid URL"}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <SettingsInput
            placeholder={"https://www.example.com"}
            form={form}
            value={form.profileUrl}
            enabled={true}
            allowEdit={true}
            name={"profileUrl"}
            type={"text"}
            inputStyles={{ width: "400px" }}
            errors={errors}
            label={"OMS+ Customer Profile URL"}
            subtitle={"The Url to open a customer profile in OMS+. Applies to all locations unless overridden."}
            onChangeValue={onChangeFormField}
            register={register({
              validate: validateUrl,
              maxLength: { value: MAX_URL_LENGTH, message: `URL must be fewer than ${MAX_URL_LENGTH} characters` }
            })}
            validateMessage={"Invalid URL"}
          />
        </Col>
      </Row>
    </SettingsWrapper>
  );
};

export default AccountAdvancedSettings;
